import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Selector from "../../../Selector";
import useStyles from "../../style";

export function SearchFarmField({ mainGroup, farms, filteredFarm, setFilteredFarm }) {
  const classes = useStyles();
  const [hasSingleFarm, setHasSingleFarm] = useState(true);

  useEffect(() => {
    if (farms) {      
      setHasSingleFarm(farms.length <= 1);
    }
  }, [farms, setHasSingleFarm]);

  return (
    mainGroup === "farmer" && (
      <Selector
        options={farms}
        className={classes.filter}
        isClearable={true}
        isDisabled={hasSingleFarm}
        value={filteredFarm}
        label="Selecione a Fazenda"
        onChange={(value) => setFilteredFarm(value)}
        placeholder="Digite ou busque a fazenda..."
        isMulti={false}
        width="100%"
      />
    )
  );
}

SearchFarmField.propTypes = {
  farms: PropTypes.array.isRequired,
  setFilteredFarm: PropTypes.func.isRequired,
  mainGroup: PropTypes.string.isRequired,
  filteredFarm: PropTypes.object,
};

SearchFarmField.defaultProps = {
  farms: [],
};

const mapState = ({farms: { farms, filteredFarm}}) => ({
  farms: farms.map((f) => ({...f, value: f.id, label: f.description })),
  filteredFarm: filteredFarm ? { ...filteredFarm, value: filteredFarm.id, label: filteredFarm.description } : null
});

const mapDispatch = (dispatch) => ({
  setFilteredFarm: (farm) => dispatch.farms.setFilteredFarm(farm)
}); 

export default connect(mapState,mapDispatch)(SearchFarmField);
